/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Stack } from '@fluentui/react/lib/Stack';
import { observer } from 'mobx-react';
import * as React from 'react';
import { LuisText } from 'src/core/components/LuisText';
import { getScopedTheme } from 'src/core/themes/luisStylist';
import { QnaMakerSynonymStore } from 'src/qnaMaker/core/stores/QnaMakerSynonymStore';
import styled from 'styled-components';

type QnaMakerSynonymCardProps = {
    isSelected: boolean;
    setIsSelected: () => void;
    synData: QnaMakerSynonymStore;
};

const theme = getScopedTheme('QnaMakerSynonymCard');

const Container = styled(Stack)<{ isSelected: boolean }>(props => ({
    cursor: 'pointer',
    borderBottom: theme.bottomBorder,
    backgroundColor: props.isSelected ? theme.focussingColor : 'unset',
    forcedColorAdjust: 'none',
    '&:hover': {
        backgroundColor: theme.hoveringColor
    }
}));

export const QnaMakerSynonymCard = observer((props: QnaMakerSynonymCardProps) => {
    const { synData, isSelected, setIsSelected } = props;

    return (
        <Container
            horizontal
            data-is-focusable
            isSelected={isSelected}
            onClick={setIsSelected}
            onFocus={setIsSelected}
            id={`synonym${synData.id}`}
            tokens={{ childrenGap: 5, padding: '20px 10px' }}>
            <LuisText>{synData.alterations.join(', ')}</LuisText>
        </Container>
    );
});
